import { useNavigate } from 'react-router-dom'
import { useIsMomMode } from '../../hooks/useIsMomMode'
import { useAuth } from '../../hooks/useAuth'
import { Card } from '../../components/ui'

export default function MomSettings() {
  const { consignee, loading } = useIsMomMode()
  const { signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/sign-in', { replace: true })
  }

  if (loading) return null

  return (
    <div style={{ padding: 'var(--space-6)' }}>
      <h1 style={{ marginBottom: 'var(--space-4)' }}>Settings</h1>

      {consignee && (
        <Card style={{ marginBottom: 'var(--space-4)' }}>
          <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-faint)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 'var(--space-1)' }}>
            Your cut
          </div>
          <div style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700 }}>
            {consignee.cut_pct}%
          </div>
          <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)', marginTop: 'var(--space-1)' }}>
            Set by the shop owner. Contact them if it needs to change.
          </div>
        </Card>
      )}

      <button
        type="button"
        onClick={handleSignOut}
        style={{
          width: '100%',
          padding: 'var(--space-3) var(--space-5)',
          color: 'var(--color-danger)',
          border: '1px solid var(--color-danger)',
          borderRadius: 'var(--radius-md)',
          fontWeight: 600,
          fontSize: 'var(--font-size-sm)',
          background: 'transparent',
        }}
      >
        Sign out
      </button>
    </div>
  )
}
